import React from 'react';
import PropTypes from 'prop-types';
import SovosIconMenu from 's1-ui/sovos-icon-menu/SovosIconMenu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import MoreVert from '@material-ui/icons/MoreVert';

const ContextualGridMenuOptions = ({
  downloadAllDisabled,
  onDownloadAll,
  fontSize,
  selectedItems,
  editDisabled,
  onEdit,
  onDelete,
  deleteDisabled,
  onDownload,
  downloadDisabled,
  elementId,
  downloadSelectedDisabled,
  onDownloadSelected
}) => (
  <SovosIconMenu
    iconElement={ <MoreVert /> }
    anchorOrigin={ { horizontal: 'right', vertical: 'top' } }
    targetOrigin={ { horizontal: 'right', vertical: 'top' } }
  >
    {!editDisabled && (
      <MenuItem
        style={ { fontSize: fontSize } }
        onClick={ () => onEdit(elementId) }
      >
        Edit
      </MenuItem>
    )}
    {!downloadDisabled && (
      <MenuItem
        style={ { fontSize: fontSize } }
        onClick={ () => onDownload(elementId) }
      >
        Download
      </MenuItem>
    )}
    {!downloadAllDisabled && (
      <MenuItem
        style={ { fontSize: fontSize } }
        onClick={ () => onDownloadAll(elementId) }
      >
        Download All
      </MenuItem>
    )}
    {!deleteDisabled && (
      <MenuItem
        style={ { fontSize: fontSize } }
        onClick={ () => onDelete(elementId) }
      >
        Delete
      </MenuItem>
    )}
    {selectedItems.length > 0 && !downloadSelectedDisabled && (
      <MenuItem
        style={ { fontSize: fontSize } }
        onClick={ () => onDownloadSelected(elementId) }
      >
        Download Selected
      </MenuItem>
    )}
  </SovosIconMenu>
);

ContextualGridMenuOptions.propTypes = {
  elementId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
  onDownloadAll: PropTypes.func,
  editDisabled: PropTypes.bool,
  deleteDisabled: PropTypes.bool,
  downloadDisabled: PropTypes.bool,
  onDownloadSelected: PropTypes.func,
  downloadAllDisabled: PropTypes.bool,
  downloadSelectedDisabled: PropTypes.bool,
  selectedItems: PropTypes.array,
  fontSize: PropTypes.string
};

ContextualGridMenuOptions.defaultProps = {
  onEdit: () => null,
  onDelete: () => null,
  onDownload: () => null,
  onDownloadAll: () => null,
  onDownloadSelected: () => null,
  editDisabled: true,
  deleteDisabled: true,
  downloadDisabled: true,
  downloadSelectedDisabled: true,
  downloadAllDisabled: true,
  selectedItems: [],
  fontSize: '16px'
};

export default ContextualGridMenuOptions;



// WEBPACK FOOTER //
// ./src/shared/contextualGridMenuOptions/ContextualGridMenuOptions.js